import React from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import { Row, Separator } from '@fs/zion-ui'

export default function CenteredLoadingSpinner(): JSX.Element {
  return (
    <div data-testid="loading-spinner">
      <Separator size="lg" />
      <Row alignX="center">
        <div>
          <NoticeLoading size="lg" />
        </div>
      </Row>
      <Separator size="lg" />
    </div>
  )
}
